import { useSettings } from '@/data/settings';
import { DefaultSeo as NextDefaultSeo } from 'next-seo';

function getCanonicalUrl(path) {
  const baseUrl = 'https://promptsclub.com'; // Deine Basis-URL
  const url = new URL(path, baseUrl);

  // Liste der zu bewahrenden Parameter
  const keepParams = ['types', 'categories', 'tags', 'aiModels'];
  const params = new URLSearchParams(url.search);
  const newParams = new URLSearchParams();

  // Übergehe die Suchparameter und behalte nur die relevanten mit nicht-leeren Werten
  for (const key of keepParams) {
    const value = params.get(key);
    if (params.has(key) && value !== null && value.trim() !== '') {
      newParams.set(key, value);
    }
  }

  // Setze die erlaubten Suchparameter zurück in die URL
  url.search = newParams.toString();
  return url.toString();
}


const DefaultSeo = ({ path }: any) => {
  const { settings } = useSettings();

  return (
    <NextDefaultSeo
      additionalMetaTags={[
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1 maximum-scale=1',
        },
        {
          name: 'apple-mobile-web-app-capable',
          content: 'yes',
        },
        {
          name: 'theme-color',
          content: '#ffffff',
        },
      ]}
      additionalLinkTags={[
        {
          rel: 'apple-touch-icon',
          href: 'icons/apple-icon-180.png',
        },
        {
          rel: 'manifest',
          href: '/manifest.json',
        },
      ]}
      // title={'Prompts Club'}
      titleTemplate={`%s | Prompts Club`}
      // defaultTitle="Prompts Club"
      /* description={settings?.seo?.metaDescription || settings?.siteSubtitle} */
      canonical={getCanonicalUrl(path)}
      openGraph={{
        title: settings?.seo?.ogTitle,
        description: settings?.seo?.ogDescription,
        type: 'website',
        locale: 'en_US',
        site_name: settings?.siteTitle,
        images: [
          {
            url: settings?.seo?.ogImage?.original ?? '',
            width: 800,
            height: 600,
            alt: settings?.seo?.ogTitle,
          },
        ],
      }}
      twitter={{
        handle: settings?.seo?.twitterHandle,
        site: settings?.siteTitle,
        cardType: settings?.seo?.twitterCardType,
      }}
    />
  );
};

export default DefaultSeo;
